import Register from '../../../utils/Register';
import naja from 'naja';
import {Modal as BootstrapModal} from 'bootstrap-show-modal/src/ShowModal';

/**

Musí být div.js-cart-transport-payments který obaluje celou komponentu.
Jednotlivé itemy s [data-url] a [data-transport] nebo [data-payment].
Uvnitř jednotlivých itemů musí být input:checkbox name transport nebo payment.

class:
	item: .tp-list__item
	+ aktivní item: .tp-list__item--active
	+ zablokovaný item: .tp-list__item--inactive

 */
export default class TransportPaymentChooser {

    constructor ($container) {
        const _this = this;
        this.transportPaymentRelations = {};

		$container.filterAllNodes('.js-cart-transport-payments :checkbox').each(function(i, el) {
			$(this).data('checked', $(this).prop('checked'));
		});
		
        $container.filterAllNodes('.js-cart-transport-payments [data-url]').on('click', function(e) {
			if ($(this).is('.tp-list__item--inactive') || $(e.target).is('a')) {
				e.preventDefault();
				return;
			}

			const checkbox = $(this).find(':checkbox');
		
			if ($(e.target).is(':checkbox') == false) {
				checkbox.prop('checked', checkbox.prop('checked') ? false : true) ;
			} else {
				checkbox.prop('checked', checkbox.data('checked') ? false : true);
			}
			checkbox.data('checked', checkbox.prop('checked'));

			_this.toggle(checkbox);
		});
			
		const transportPaymentRelations = $('.js-cart-transport-payments');
		transportPaymentRelations.data('relations').forEach(item => {
			this.addTransportPaymentRelation(item.transportId, item.paymentId);
		});

		$container.find('#pickup-point-selector').on('click', function(e) {
			e.preventDefault();
			_this.transportPicker($(this).closest('[data-transport]').data('shipping-service'));
		});
    }
    
    toggle (checkbox) {
		
		if (checkbox.is('[name="transport"]')) {
			const currentTransport = $('.js-cart-transport-payments [name="transport"]:checked').not(checkbox);
			if (currentTransport.length > 0) {
				currentTransport.closest('[data-transport]').removeClass('tp-list__item--active');
				currentTransport.prop('checked', false).data('checked', false);
			}
			
			if (checkbox.prop('checked')) {
				checkbox.closest('[data-transport]').addClass('tp-list__item--active');
			} else {
				checkbox.closest('[data-transport]').removeClass('tp-list__item--active');
			}
					
			naja.makeRequest('GET', checkbox.closest('[data-transport]').data('url'), null, {
				history: false
			}).then(() => {
				if (currentTransport.length > 0) {
					currentTransport.closest('[data-transport]').addClass('tp-list__item--active');
					currentTransport.prop('checked', true).data('checked', true);
				}
				
				if (checkbox.prop('checked')) {
					checkbox.closest('[data-transport]').removeClass('tp-list__item--active');
					checkbox.prop('checked', false).data('checked', false);

					this.transportPicker(checkbox.closest('[data-transport]').data('shipping-service'));
				} else {
					checkbox.closest('[data-transport]').addClass('tp-list__item--active');
					checkbox.prop('checked', true).data('checked', true);
				}
			});
		} else {
			const currentPayment = $('.js-cart-transport-payments [name="payment"]:checked').not(checkbox);
			if (currentPayment.length > 0) {
				currentPayment.closest('[data-payment]').removeClass('tp-list__item--active');
				currentPayment.prop('checked', false).data('checked', false);
			}
			
			if (checkbox.prop('checked')) {
				checkbox.closest('[data-payment]').addClass('tp-list__item--active');
			} else {
				checkbox.closest('[data-payment]').removeClass('tp-list__item--active');
			}
					
			naja.makeRequest('GET', checkbox.closest('[data-payment]').data('url'), null, {
				history: false
			}).then(() => {
				if (currentPayment.length > 0) {
					currentPayment.closest('[data-payment]').addClass('tp-list__item--active');
					currentPayment.prop('checked', true).data('checked', true);
				}
				
				if (checkbox.prop('checked')) {
					checkbox.closest('[data-payment]').removeClass('tp-list__item--active');
					checkbox.prop('checked', false).data('checked', false);
				} else {
					checkbox.closest('[data-payment]').addClass('tp-list__item--active');
					checkbox.prop('checked', true).data('checked', true);
				}
			});			
		}

    }
    
    addTransportPaymentRelation(transportId, paymentId) {
        if (this.transportPaymentRelations[transportId] === undefined) {
            this.transportPaymentRelations[transportId] = {};
        }
        this.transportPaymentRelations[transportId][paymentId] = true;
    }

    transportPaymentRelationExists(transportId, paymentId) {
        if (this.transportPaymentRelations[transportId] !== undefined) {
            if (this.transportPaymentRelations[transportId][paymentId] !== undefined) {
                return this.transportPaymentRelations[transportId][paymentId];
            }
        }

        return false;
    }    
    
    updateTransportPaymentRelations() {
		const _this = this;
		const $transport = $('.js-cart-transport-payments [name="transport"]:checked').closest('[data-transport]');
		const $payment = $('.js-cart-transport-payments [name="payment"]:checked').closest('[data-payment]');
		
		if ($transport.length > 0) {
			$('.js-cart-transport-payments [data-payment]').each(function(i, el) {
				if (_this.transportPaymentRelationExists($transport.data('transport'), $(el).data('payment'))) {
                    $(el).find(':checkbox').prop('disabled', false);
                    $(el).removeClass('tp-list__item--inactive');
                } else {
                    $(el).find(':checkbox').prop('disabled', true);
                    $(el).addClass('tp-list__item--inactive');
                }
			});
		} else {
			$('.js-cart-transport-payments [data-payment]').each(function(i, el) {
                $(el).find(':checkbox').prop('disabled', false);
                $(el).removeClass('tp-list__item--inactive');
			});			
		}
		
		if ($payment.length > 0) {
			$('.js-cart-transport-payments [data-transport]').each(function(i, el) {
				if (_this.transportPaymentRelationExists($(el).data('transport'), $payment.data('payment'))) {
                    $(el).find(':checkbox').prop('disabled', false);
                    $(el).removeClass('tp-list__item--inactive');
                } else {
                    $(el).find(':checkbox').prop('disabled', true);
                    $(el).addClass('tp-list__item--inactive');
                }
			});
		} else {
			$('.js-cart-transport-payments [data-transport]').each(function(i, el) {
                $(el).find(':checkbox').prop('disabled', false);
                $(el).removeClass('tp-list__item--inactive');
			});			
		}
	}

	transportPicker(service) {
		switch (service) {
			case 'ceska_posta-balikovna':
				this.ceskaPostaOpen('BALIKOVNY');
			break;
			case 'ceska_posta-na_postu':
				this.ceskaPostaOpen('POST_OFFICE');
			break;
			case 'gls-shop_delivery':

			break;
			case 'ppl-parcel_shop_cz':

			break;
			case 'ppl-parcel_shop_sk':

			break;
			case 'slovenska_posta-balikobox':
				this.slovenskaPostaOpen(['bbox'], 'b');
			break;
			case 'slovenska_posta-express_balikobox':
				this.slovenskaPostaOpen(['bbox'], 'ex');
			break;
			case 'slovenska_posta-zmluvni_balikobox':
				this.slovenskaPostaOpen(['bbox'], 'zb');
			break;
			case 'slovenska_posta-na_postu':
				this.slovenskaPostaOpen(['office'], 'b');
			break;
			case 'slovenska_posta-express_na_postu':
				this.slovenskaPostaOpen(['office'], 'ex');
			break;
			case 'slovenska_posta-zmluvni_na_postu':
				this.slovenskaPostaOpen(['office'], 'zb');
			break;
			case 'slovak_parcel_service-parcel_shop':

			break;
			case 'zasilkovna-pobocky_a_boxy':
				this.packetaOpen();
			break;
		}
	}

	ceskaPostaOpen(type = null) {
		const _this = this;
		// https://www.balikovna.cz/documents/20124/5404475/Bal%C3%ADkovna_widget_implementace.pdf/4dfae2f6-3972-90dd-4a26-4fbab49daebb?t=1719310469897
		// https://www.npmjs.com/package/bootstrap-show-modal

		let iframeUrl = 'https://b2c.cpost.cz/locations/';
		if (type !== null) {
			iframeUrl += '?type=' + type;
		}

		let ceskaPostaPoint = null;

		const pickerListener = function(event) {
			if (event.data.message == 'pickerResult') {
				ceskaPostaPoint = event.data.point;
				bootstrapModal.hide();
			}
		}

		const bootstrapModal = bootstrap.showModal({
			title: 'Česká Pošta',
			body: '<iframe src="' + iframeUrl + '" allow="geolocation" width="100%" height="100%" />',
			modalDialogClass: 'modal-xl modal-dialog-centered',
			onShown: function() {
				ceskaPostaPoint = null;
				window.addEventListener('message', pickerListener);
			},
			onDispose: function() {
				window.removeEventListener('message', pickerListener);
				_this.transportPickerCallback(ceskaPostaPoint);
			}
		});

		const modalEl = document.querySelector('#' + bootstrapModal.id);
		modalEl.querySelector('.modal-dialog').style.height = 'calc(100% - var(--bs-modal-margin) * 2)';
		modalEl.querySelector('.modal-content').style.height = '100%';
	}

	slovenskaPostaOpen(branchKinds, shippmentType) {
		slposta.PickupWidget.open({
			callback: this.transportPickerCallback,
			branchKinds: branchKinds,
			shippmentType: shippmentType
		});
	}
	packetaOpen() {
		Packeta.Widget.pick(packetaApiKey, this.transportPickerCallback, packetaOptions);
	}

	transportPickerCallback(point) {
		if (point === null) {
			const transportEl = document.querySelector('[data-transport][data-selected]');
			if (transportEl) {
				transportEl.click();
			}
		} else {
			const pickupPointUrl = document.querySelector('.js-cart-transport-payments').dataset.pickupPointUrl;
			naja.makeRequest('POST', pickupPointUrl, {
				point: point
			}, {
				history: false
			});
		}
	}

    static init ($container) {
		if ($container.find('.js-cart-transport-payments').length > 0) {
	        const transportPaymentChooser = new TransportPaymentChooser($container);
	        transportPaymentChooser.updateTransportPaymentRelations();
        }
    }

}

(new Register()).registerCallback(TransportPaymentChooser.init, 'TransportPaymentChooser.init');